import { render } from "./SelectWorkDialog.vue?vue&type=template&id=697650e1"
import script from "./SelectWorkDialog.vue?vue&type=script&lang=js"
export * from "./SelectWorkDialog.vue?vue&type=script&lang=js"

import "./SelectWorkDialog.vue?vue&type=style&index=0&id=697650e1&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__